export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9447.d516ac6f.jpg";